import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestStatsMainGet = {
    path: "/stats/main",
    method: RouteHttpVerb.GET
};
export { locationRestStatsMainGet };
